// What differs between the three All Transactions histories. The table, date
// filter, paging and wording rules are shared (AllTransactionsModal.jsx).

export const RENTALS_ALL_TRANSACTIONS = {
  endpoint: "/frp/all-transactions",
  subtitle: "Your Rentals money, newest first",
  owedLabel: "You owe (all units)",
  noSignNote: "No sign: a bill, no money moved.",
  owedNote: "\"You owe\" is what that unit still needs from you after the row.",
}

export const BILLS_ALL_TRANSACTIONS = {
  endpoint: "/ut-bills/all-transactions",
  subtitle: "Your Bills & Invoices money, newest first",
  owedLabel: "You owe (all companies)",
  noSignNote: "No sign: a bill or a change to it, no money moved in your wallet.",
  owedNote: "\"You owe\" is your Bills & Invoices balance after the row, as on your My Bills statement.",
}

export const GROUPS_ALL_TRANSACTIONS = {
  endpoint: "/groups/all-transactions",
  subtitle: "Your Groups money, newest first",
  owedLabel: "You owe (all groups)",
  noSignNote: "No sign: a bill or a change to it, no money moved in your wallet.",
  owedNote: "\"You owe\" is what that group still needs from you after the row.",
}
